import { Rows2, Rows4 } from 'lucide-react';
import { SegmentedControl, type Segment } from '../ui/SegmentedControl.js';
import type { RowDensity } from './useGridPreferences.js';

const DENSITIES: readonly Segment<RowDensity>[] = [
  { value: 'comfortable', label: 'Comfortable', icon: Rows2 },
  { value: 'compact', label: 'Compact', icon: Rows4 },
];

/**
 * Icons only: set once and left, and the two icons draw the rows they give,
 * so the words would buy nothing but toolbar width. They are the tooltip.
 */
export function DensityToggle(props: {
  density: RowDensity;
  onChange: (density: RowDensity) => void;
}): React.JSX.Element {
  return (
    <SegmentedControl
      label="How tall the rows are"
      iconOnly
      value={props.density}
      options={DENSITIES}
      onChange={props.onChange}
    />
  );
}
